export const PermissaoUsuarioEnum = {
	VISUALIZAR: "VISUALIZAR_USUARIO",
	CRIAR: "CRIAR_USUARIO",
	EXCLUIR: "EXCLUIR_USUARIO",
};

export const PermissaoGrupoUsuarioEnum = {
	VISUALIZAR: "VISUALIZAR_GRUPO_USUARIO",
	CRIAR: "CRIAR_GRUPO_USUARIO",
	EXCLUIR: "EXCLUIR_GRUPO_USUARIO",
};

export const PermissaoEmpresaEnum = {
	VISUALIZAR: "VISUALIZAR_EMPRESA",
	CRIAR: "CRIAR_EMPRESA",
	EXCLUIR: "EXCLUIR_EMPRESA",
	DESATIVAR: "DESATIVAR_EMPRESA",
	DEFINIR_RESPONSAVEL_SETOR: "DEFINIR_RESPONSAVEL_SETOR",
	VISUALIZAR_ALERTAS_EMPRESAS: "VISUALIZAR_ALERTAS_EMPRESAS",
};

export const PermissaoRegraEnum = {
	VISUALIZAR: "VISUALIZAR_REGRA_CONFIGURACAO",
	CRIAR: "CRIAR_REGRA_CONFIGURACAO",
	EXCLUIR: "EXCLUIR_REGRA_CONFIGURACAO",
	VERIFICAR: "VERIFICAR_REGRA_CONFIGURACAO",
	VISUALIZAR_ALERTAS_REGRAS: "VISUALIZAR_ALERTAS_REGRAS_CONFIGURACAO",
	EDITAR_REGRA_COMO_ADMINISTRADOR:
		"EDITAR_REGRA_COMO_ADMINISTRADOR_CONFIGURACAO",
	VISUALIZAR_LOGS_REGRAS: "VISUALIZAR_LOGS_REGRAS_CONFIGURACAO",
	EXCLUIR_LOGS_REGRAS: "EXCLUIR_LOGS_REGRAS_CONFIGURACAO",
};

export const PermissaoAlertaEnum = {
	VISUALIZAR: "VISUALIZAR_ALERTA",
	RESOLVER: "RESOLVER_ALERTA",
	FILTRAR_ALERTA_POR_RESPONSAVEL: "FILTRAR_ALERTA_POR_RESPONSAVEL",
};

export const PermissaoConfiguracaoGeralEnum = {
	CONFIGURAR: "CONFIGURAR_CONFIGURACAO_GERAL",
};

export const PermissaoDepartamentoEnum = {
	VISUALIZAR: "VISUALIZAR_DEPARTAMENTO",
	CRIAR: "CRIAR_DEPARTAMENTO",
	EXCLUIR: "EXCLUIR_DEPARTAMENTO",
};

export const PermissaoCategoriaPermissaoEnum = {
	VISUALIZAR: "VISUALIZAR_CATEGORIA_PERMISSAO",
	CRIAR: "CRIAR_CATEGORIA_PERMISSAO",
	EDITAR: "EDITAR_CATEGORIA_PERMISSAO",
	EXCLUIR: "EXCLUIR_CATEGORIA_PERMISSAO",
	GERENCIAR_PERMISSOES: "GERENCIAR_PERMISSOES_CATEGORIA_PERMISSAO",
};

export const PermissaoBancoFonteEnum = {
	VISUALIZAR: "VISUALIZAR_BANCO_FONTE",
	CRIAR: "CRIAR_BANCO_FONTE",
	EDITAR: "EDITAR_BANCO_FONTE",
	EXCLUIR: "EXCLUIR_BANCO_FONTE",
};

export const PermissaoTenantEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_TENANT",
	CRIAR: "CRIAR_TENANT",
	EDITAR: "EDITAR_TENANT",
});

export const PermissaoWorkerEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_WORKER",
	CRIAR: "CRIAR_WORKER",
	EDITAR: "EDITAR_WORKER",
	EXCLUIR: "EXCLUIR_WORKER",
});

export const PermissaoRodarRegrasEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_RODAR_REGRAS",
	CRIAR: "CRIAR_RODAR_REGRAS",
	EDITAR: "EDITAR_RODAR_REGRAS",
	EXCLUIR: "EXCLUIR_RODAR_REGRAS",
});

export const PermissaoVinculoRegraEmpresaEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_VINCULO_REGRA_EMPRESA",
	GERENCIAR: "GERENCIAR_VINCULO_REGRA_EMPRESA",
});

export const PermissaoWhatsAppEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_WHATSAPP",
	CRIAR: "CRIAR_WHATSAPP",
	EDITAR: "EDITAR_WHATSAPP",
	EXCLUIR: "EXCLUIR_WHATSAPP",
	GERENCIAR_INSTANCIA: "GERENCIAR_INSTANCIA_WHATSAPP",
});

export const PermissaoFunilVendaEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_FUNIL_VENDA",
	EDITAR: "EDITAR_FUNIL_VENDA",
});

export const PermissaoAgendaEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_AGENDA",
	EDITAR: "EDITAR_AGENDA",
});

export const PermissaoAgendamentoSistemaEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_AGENDAMENTO_SISTEMA",
	CRIAR: "CRIAR_AGENDAMENTO_SISTEMA",
	EDITAR: "EDITAR_AGENDAMENTO_SISTEMA",
	EXCLUIR: "EXCLUIR_AGENDAMENTO_SISTEMA",
});

export const PermissaoFornecedorPendenciaEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_FORNECEDOR_PENDENCIA",
	EDITAR: "EDITAR_FORNECEDOR_PENDENCIA",
});

export const PermissaoPortalFiscalEnum = Object.freeze({
	VISUALIZAR_CFOP: "VISUALIZAR_PORTAL_FISCAL_CFOP",
	EDITAR_CFOP: "EDITAR_PORTAL_FISCAL_CFOP",
	VISUALIZAR_LOG_CFOP: "VISUALIZAR_PORTAL_FISCAL_LOG_CFOP",
	VISUALIZAR_LOG_AUTO_CFOP: "VISUALIZAR_PORTAL_FISCAL_LOG_AUTO_CFOP",
	VISUALIZAR_CRUZAMENTO: "VISUALIZAR_PORTAL_FISCAL_CRUZAMENTO",
	VISUALIZAR_CRUZAMENTO_SAIDA: "VISUALIZAR_PORTAL_FISCAL_CRUZAMENTO_SAIDA",
	VISUALIZAR_LOG_CRUZAMENTO: "VISUALIZAR_PORTAL_FISCAL_LOG_CRUZAMENTO",
	VISUALIZAR_DIAGNOSTICO: "VISUALIZAR_PORTAL_FISCAL_DIAGNOSTICO",
});

export const PermissaoPortalContabilEnum = Object.freeze({
	VISUALIZAR_BLOQUEIOS: "VISUALIZAR_PORTAL_CONTABIL_BLOQUEIOS",
	VISUALIZAR_LOG_BLOQUEIOS: "VISUALIZAR_PORTAL_CONTABIL_LOG_BLOQUEIOS",
});

export const PermissaoPortalSocietarioEnum = Object.freeze({
	VISUALIZAR_CONTRATOS: "VISUALIZAR_PORTAL_SOCIETARIO_CONTRATOS",
	VISUALIZAR_ATUALIZADOR: "VISUALIZAR_PORTAL_SOCIETARIO_ATUALIZADOR",
	VISUALIZAR_CERTIFICADOS: "VISUALIZAR_PORTAL_SOCIETARIO_CERTIFICADOS",
});

export const PermissaoPortalGestaoEnum = Object.freeze({
	VISUALIZAR_VISAO_CARTEIRA: "VISUALIZAR_PORTAL_GESTAO_VISAO_CARTEIRA",
	VISUALIZAR_FINANCEIRO: "VISUALIZAR_PORTAL_GESTAO_FINANCEIRO",
	VISUALIZAR_SITUACAO_MODULOS: "VISUALIZAR_PORTAL_GESTAO_SITUACAO_MODULOS",
});

export const PermissaoPortalRotinasEnum = Object.freeze({
	VISUALIZAR_PAINEL: "VISUALIZAR_PORTAL_ROTINAS_PAINEL",
	VISUALIZAR_TIPOS: "VISUALIZAR_PORTAL_ROTINAS_TIPOS",
	VISUALIZAR_DOMICILIOS: "VISUALIZAR_PORTAL_ROTINAS_DOMICILIOS",
});

export const PermissaoPortalAvisosEnum = Object.freeze({
	VISUALIZAR_OMIE: "VISUALIZAR_PORTAL_AVISOS_OMIE",
	VISUALIZAR_ZEN: "VISUALIZAR_PORTAL_AVISOS_ZEN",
});

export const PermissaoPortalFolhaEnum = Object.freeze({
	VISUALIZAR: "VISUALIZAR_PORTAL_FOLHA",
});
